/**
 * Header Premium - Synchronisation avec les thèmes saisonniers
 * Détecte automatiquement le thème de la barre d'annonce et applique les styles correspondants
 */

(function() {
  'use strict';

  // Détecter le thème de la barre d'annonce
  function detectAnnouncementTheme() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (!announcementBar) return null;

    // Vérifier les classes CSS pour le thème
    const themes = ['black-friday', 'christmas', 'spring', 'summer', 'autumn', 'winter', 'valentine', 'easter'];
    for (const theme of themes) {
      if (announcementBar.classList.contains(`announcement-bar--${theme}`)) {
        return theme;
      }
    }

    // Vérifier l'attribut data-theme
    const dataTheme = announcementBar.getAttribute('data-theme');
    if (dataTheme && themes.includes(dataTheme)) {
      return dataTheme;
    }

    return null;
  }

  // Appliquer le thème au header
  function applyThemeToHeader(theme) {
    const headerWrapper = document.querySelector('.header-wrapper');
    if (!headerWrapper) return;

    // Supprimer toutes les classes de thème existantes
    const themes = ['black-friday', 'christmas', 'spring', 'summer', 'autumn', 'winter', 'valentine', 'easter'];
    themes.forEach(t => {
      headerWrapper.classList.remove(`header--${t}`);
    });

    // Ajouter la classe du nouveau thème
    if (theme) {
      headerWrapper.classList.add(`header--${theme}`);
    }
  }

  // Observer les changements de la barre d'annonce
  function observeAnnouncementBar() {
    const announcementBar = document.querySelector('.announcement-bar');
    if (!announcementBar) return;

    const observer = new MutationObserver(() => {
      const theme = detectAnnouncementTheme();
      applyThemeToHeader(theme);
    });

    observer.observe(announcementBar, {
      attributes: true,
      attributeFilter: ['class', 'data-theme']
    });
  }

  // Initialisation
  function init() {
    // Appliquer le thème initial
    const theme = detectAnnouncementTheme();
    applyThemeToHeader(theme);

    // Observer les changements
    observeAnnouncementBar();

    // Observer aussi le header pour les changements dynamiques
    const headerWrapper = document.querySelector('.header-wrapper');
    if (headerWrapper) {
      const headerObserver = new MutationObserver(() => {
        const theme = detectAnnouncementTheme();
        applyThemeToHeader(theme);
      });

      headerObserver.observe(document.body, {
        childList: true,
        subtree: true
      });
    }
  }

  // Attendre que le DOM soit prêt
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  // Réappliquer après le chargement complet
  window.addEventListener('load', () => {
    const theme = detectAnnouncementTheme();
    applyThemeToHeader(theme);
  });
})();

